import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { getSessionShop, useSession } from '../../../../infra/session';
import { useDebouncedCallback } from '../../../../infra/small-tools/use-debounced-callback';
import { endpoints } from '../network';
import { ClientSearchResultsView } from './client-search-results';
export var ClientSearchResultsContainer = function (_a) {
    var searchBy = _a.searchBy, onSelectClient = _a.onSelectClient, maskContactInfo = _a.maskContactInfo, show = _a.show;
    var _b = useState([]), searchResult = _b[0], setSearchResult = _b[1];
    // when client clicks cancel, we hide search results. when they type in the inputs again, we show search results again
    var shouldHideCurrentSearchResult = useRef(false);
    var session = useSession().data;
    var shop = getSessionShop(session);
    var fetchSearchResults = useDebouncedCallback(function (currentSearchBy) {
        if (currentSearchBy.length > 0) {
            shouldHideCurrentSearchResult.current = false;
            endpoints.customersSearchService
                .search({
                ownerType: 'shop',
                ownerShop: shop,
                searchString: searchBy,
            })
                .then(function (result) {
                if (!shouldHideCurrentSearchResult.current) {
                    setSearchResult(result);
                }
                shouldHideCurrentSearchResult.current = false;
            });
        }
        else {
            setSearchResult([]);
        }
    }, 300, [shop]).func;
    useEffect(function () {
        fetchSearchResults(searchBy);
    }, [searchBy]);
    var cancelSearch = function () {
        shouldHideCurrentSearchResult.current = true;
        setSearchResult(null);
    };
    var shouldShow = show && !!(searchResult === null || searchResult === void 0 ? void 0 : searchResult.length) && !shouldHideCurrentSearchResult.current;
    if (!shouldShow) {
        return null;
    }
    return (_jsx(ClientSearchResultsView, { onCancelSearchClicked: cancelSearch, searchResults: searchResult || [], onSelectClient: onSelectClient, maskContactInfo: maskContactInfo }));
};
